import React, { useEffect } from "react";
import {
  I2cInput,
  I2cRadio,
  I2cRadioButton,
  I2cRadioGroup,
  I2cCheckboxGroup,
  I2cListItem,
  I2cCheckbox,
} from "@webcomponents/i2cwebcomponents/dist/react";
import "../Prepaid.scss";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import ErrorMessage from "../../../Components/SharedComponent/ErrorMessage/ErrorMessage";
export const otpDelivery = [
  { label: "E-mail", value: "email" },
  { label: "SMS", value: "sms" },
  { label: "SMPP Integration", value: "smpp" },
  { label: "Other", value: "other" },
];
const SecureEcommerce = ({
  setAddFormData,
  addFormData,
  setFormValidStates,
  formDataJson,
  isFetching,
}) => {
  const acsServiceProvider = [
    { label: "i2c Inc.", value: "i2c Inc." },
    { label: "Other", value: "other" },
  ];
  const otpProvider = [
    { label: "i2c Inc.", value: "i2c Inc." },
    { label: "Client", value: "client" },
    { label: "Other", value: "other" },
  ];
  const handleCheckboxGroupChange = (event) => {
    let selectedOtpValue;
    if (!event.length) selectedOtpValue = event.target.value;
    else selectedOtpValue = event;
    let updatedOtpDelivery = [...methods.getValues("of_acs_otp_services")];

    if (updatedOtpDelivery.includes(selectedOtpValue)) {
      // If the card is already selected, remove it
      updatedOtpDelivery = updatedOtpDelivery.filter(
        (card) => card !== selectedOtpValue,
      );
    } else {
      // If the card is not selected, add it
      updatedOtpDelivery.push(selectedOtpValue);
    }
    if (!updatedOtpDelivery.includes("other")) {
      methods.setValue("of_acs_otp_service_other", "");
    }
    methods.setValue("of_acs_otp_services", updatedOtpDelivery);
  };
  const generalErrorMessage = "Field is required";

  const validationSchema = Yup.object({
    of_acs_enable_acs: Yup.string().required(generalErrorMessage),
    of_acs_acs_provider: Yup.string().when("of_acs_enable_acs", {
      is: (of_acs_enable_acs) =>
        of_acs_enable_acs && of_acs_enable_acs === "yes",
      then: () =>
        Yup.string().required(generalErrorMessage).min(1, generalErrorMessage),
      otherwise: () => Yup.string().optional(),
    }),
    of_acs_provider_other: Yup.string().when("of_acs_acs_provider", {
      is: (provider) => provider && provider === "other",
      then: () =>
        Yup.string().required(generalErrorMessage).min(1, generalErrorMessage),
      otherwise: () => Yup.string().optional(),
    }),
    of_acs_otp_services: Yup.array().optional(),
    of_acs_otp_service_other: Yup.string().when("of_acs_otp_services", {
      is: (otpServices) => otpServices && otpServices.includes("other"),
      then: () =>
        Yup.string().required(generalErrorMessage).min(1, generalErrorMessage),
      otherwise: () => Yup.string().optional(),
    }),
    of_acs_otp_service_provider: Yup.string()
      .required(generalErrorMessage)
      .min(1, generalErrorMessage),
    of_acs_otp_service_provider_other: Yup.string().when(
      "of_acs_otp_service_provider",
      {
        is: (serviceProvider) => serviceProvider && serviceProvider === "other",
        then: () =>
          Yup.string()
            .required(generalErrorMessage)
            .min(1, generalErrorMessage),
        otherwise: () => Yup.string().optional(),
      },
    ),
  });

  // Initialize React Hook Form with Yup resolver
  const methods = useForm({
    resolver: yupResolver(validationSchema),
    mode: "all",
    reValidateMode: "onChange",
    shouldUseNativeValidation: false,
    criteriaMode: "firstError",
    defaultValues: {
      of_acs_enable_acs: "",
      of_acs_acs_provider: "",
      of_acs_provider_other: "",
      of_acs_otp_services: [],
      of_acs_otp_service_other: "",
      of_acs_otp_service_provider: "",
      of_acs_otp_service_provider_other: "",
    },
  });

  // Controlls destructuring from the method
  const {
    control,
    formState: { errors },
  } = methods;

  const fields = [
    "of_acs_enable_acs",
    "of_acs_acs_provider",
    "of_acs_provider_other",
    "of_acs_otp_services",
    "of_acs_otp_service_other",
    "of_acs_otp_service_provider",
    "of_acs_otp_service_provider_other",
  ];
  useEffect(() => {
    if (!isFetching && Object.keys(formDataJson ?? {}).length) {
      fields.forEach((field) => {
        methods.setValue(field, formDataJson[6]["6_5"][field] ?? "");
      });
      methods.trigger();
    }
  }, [isFetching]);

  // Trigger validation when component mounts
  React.useEffect(() => {
    methods.trigger();
  }, []);

  const handleValueChanges = () => {
    const values = methods.getValues();
    setAddFormData({
      ...addFormData,
      6: {
        ...addFormData["6"],
        "6_5": { ...values },
      },
    });
  };
  // Update form validation state when errors change
  React.useEffect(() => {
    const errorsLength = Object.keys(errors).length;
    if (errorsLength === 0) setFormValidStates("6_5", true);
    else setFormValidStates("6_5", false);
  }, [Object.keys(errors).length]);

  return (
    <React.Fragment>
      <div className="forms-instance">
        <div i2c-grid="grid gap-md">
          <div i2c-grid="12">
            <div className="single-field-wrapper">
              <Controller
                name="of_acs_enable_acs"
                control={control}
                render={({ field }) => (
                  <I2cRadioGroup
                    value={methods.watch("of_acs_enable_acs")}
                    {...field}
                    name="of_acs_enable_acs"
                    onI2cChange={(e) => {
                      if (e.target.value === "no") {
                        methods.setValue("of_acs_acs_provider", "");
                        methods.setValue("of_acs_provider_other", "");
                      }
                      field.onChange(e);
                      handleValueChanges();
                      methods.trigger();
                    }}
                  >
                    {["Yes", "No"].map((radio, index) => (
                      <I2cRadioButton
                        key={index}
                        value={radio.toLocaleLowerCase()}
                      >
                        {radio}
                      </I2cRadioButton>
                    ))}
                  </I2cRadioGroup>
                )}
              />
            </div>
          </div>
          {methods.getValues("of_acs_enable_acs") === "yes" && (
            <div i2c-grid="12">
              <div className="single-field-wrapper">
                <Controller
                  name="of_acs_acs_provider"
                  control={control}
                  render={({ field }) => (
                    <I2cRadioGroup
                      label="If yes, please confirm who will be the ACS Service Provider:"
                      value={methods.watch("of_acs_acs_provider")}
                      {...field}
                      name="of_acs_acs_provider"
                      onI2cChange={(e) => {
                        methods.setValue("of_acs_provider_other", "");
                        field.onChange(e);
                        handleValueChanges();
                        methods.trigger();
                      }}
                    >
                      <div i2c-grid="grid gap-sm">
                        {acsServiceProvider.map((radio, index) => (
                          <I2cListItem
                            key={index}
                            i2c-grid="6@md"
                            variant="receipt"
                            label={radio.label}
                            sublabel=""
                            value=""
                            checked={
                              methods.watch("of_acs_acs_provider") ===
                              radio.value
                            }
                            type="checkbox"
                          >
                            <I2cRadio
                              filled
                              slot="prefix"
                              name="of_acsServiceProvider"
                              value={radio.value}
                            ></I2cRadio>
                          </I2cListItem>
                        ))}
                      </div>
                    </I2cRadioGroup>
                  )}
                />
              </div>
              {methods.getValues("of_acs_acs_provider") === "other" && (
                <div className="mt-16 halfWidth">
                  <div className="single-field-wrapper">
                    <Controller
                      name="of_acs_provider_other"
                      control={control}
                      render={({ field }) => (
                        <I2cInput
                          {...field}
                          name={"of_acs_provider_other"}
                          className="single-input-field"
                          label="Enter Details"
                          onI2cInput={(e) => {
                            const value = e.target.value;
                            field.onChange(value);
                            handleValueChanges();
                            if (value.length === 0) {
                              methods.setError("of_acs_provider_other", {
                                message: "Network other is required.",
                              });
                            } else {
                            }
                          }}
                          required
                          placeholder="Please Specify"
                          size="large"
                        />
                      )}
                    />
                    {/* <ErrorMessage
                      show={
                        errors.of_acs_provider_other &&
                        methods.formState.touchedFields.of_acs_provider_other
                          ? true
                          : false
                      }
                      message={
                        errors.of_acs_provider_other?.message ?? "Invalid input"
                      }
                    /> */}
                  </div>
                </div>
              )}
            </div>
          )}

          <div i2c-grid="12">
            <div className="single-field-wrapper">
              <Controller
                name="of_acs_otp_service_provider"
                control={control}
                render={({ field }) => (
                  <I2cRadioGroup
                    label="Please confirm, who will deliver OTP to the cardholder:"
                    value={methods.watch("of_acs_otp_service_provider")}
                    {...field}
                    name="of_acs_otp_service_provider"
                    onI2cChange={(e) => {
                      if (e.target.value !== "other") {
                        methods.setValue(
                          "of_acs_otp_service_provider_other",
                          "",
                        );
                      }
                      field.onChange(e);
                      handleValueChanges();
                      methods.trigger();
                    }}
                  >
                    <div i2c-grid="grid gap-sm">
                      {otpProvider.map((radio, index) => (
                        <I2cListItem
                          key={index}
                          i2c-grid="4@md"
                          variant="receipt"
                          label={radio.label}
                          sublabel=""
                          value=""
                          checked={
                            methods.watch("of_acs_otp_service_provider") ===
                            radio.value
                          }
                          onI2cCheckboxClicked={() =>
                            methods.setValue(
                              "of_acs_otp_service_provider",
                              radio.value,
                            )
                          }
                          type="checkbox"
                        >
                          <I2cRadio
                            slot="prefix"
                            filled
                            value={radio.value}
                            checked={
                              methods.watch("of_acs_otp_service_provider") ===
                              radio.value
                            }
                            onI2cChange={() =>
                              methods.setValue(
                                "of_acs_otp_service_provider",
                                radio.value,
                              )
                            }
                          ></I2cRadio>
                        </I2cListItem>
                      ))}
                    </div>
                  </I2cRadioGroup>
                )}
              />
            </div>
            {methods.getValues("of_acs_otp_service_provider") === "other" && (
              <div className="halfWidth mt-16">
                <div className="single-field-wrapper">
                  <Controller
                    name="of_acs_otp_service_provider_other"
                    control={control}
                    render={({ field }) => (
                      <I2cInput
                        {...field}
                        name={"of_acs_otp_service_provider_other"}
                        className="single-input-field"
                        label="Enter Details"
                        onI2cInput={(e) => {
                          const value = e.target.value;
                          field.onChange(value);
                          handleValueChanges();
                          if (value.length === 0) {
                            methods.setError(
                              "of_acs_otp_service_provider_other",
                              {
                                message: "Network other is required.",
                              },
                            );
                          } else {
                          }
                        }}
                        placeholder="Please Specify"
                        required
                        size="large"
                      />
                    )}
                  />
                  {/* <ErrorMessage
                    show={
                      errors.of_acs_otp_service_provider_other &&
                      methods.formState.touchedFields
                        .of_acs_otp_service_provider_other
                        ? true
                        : false
                    }
                    message={
                      errors.of_acs_otp_service_provider_other?.message ??
                      "Invalid input"
                    }
                  /> */}
                </div>
              </div>
            )}
          </div>

          <div i2c-grid="12">
            <div className="single-field-wrapper">
              <Controller
                name="of_acs_otp_services"
                control={control}
                render={({ field }) => (
                  <>
                    <I2cCheckboxGroup
                      label=" How would you like the OTP to be delivered to cardholders:"
                      {...field}
                      className="centeredCheckbox"
                    >
                      <div i2c-grid="grid gap-sm">
                        {otpDelivery.map((card, index) => (
                          <I2cListItem
                            key={index}
                            i2c-grid="6@md"
                            variant="receipt"
                            label={card.label}
                            sublabel=""
                            value=""
                            type="checkbox"
                            checked={methods
                              .watch("of_acs_otp_services")
                              .includes(card.value)}
                            onI2cCheckboxClicked={(e) => {
                              handleCheckboxGroupChange(card.value);
                              handleValueChanges();
                              methods.trigger();
                            }}
                          >
                            <I2cCheckbox
                              slot="prefix"
                              value={card.value}
                              label=""
                              filled
                              ignoreTab
                              checked={methods
                                .watch("of_acs_otp_services")
                                .includes(card.value)}
                           
                              className="customCheckbox"
                            ></I2cCheckbox>
                          </I2cListItem>
                        ))}
                      </div>
                    </I2cCheckboxGroup>
                    <ErrorMessage
                      show={
                        errors.of_acs_otp_services &&
                        methods.formState.touchedFields.of_acs_otp_services
                          ? true
                          : false
                      }
                      message={
                        errors.of_acs_otp_services?.message ?? "Invalid input"
                      }
                    />
                  </>
                )}
              />
            </div>
            {methods.getValues("of_acs_otp_services").includes("other") && (
              <div className="halfWidth mt-16">
                <div className="single-field-wrapper">
                  <Controller
                    name="of_acs_otp_service_other"
                    control={control}
                    render={({ field }) => (
                      <I2cInput
                        {...field}
                        name={"of_acs_otp_service_other"}
                        className="single-input-field"
                        label="Enter Details"
                        onI2cInput={(e) => {
                          const value = e.target.value;
                          field.onChange(value);
                          handleValueChanges();
                          if (value.length === 0) {
                            methods.setError("of_acs_otp_service_other", {
                              message: "Network other is required.",
                            });
                          } else {
                          }
                        }}
                        placeholder="Please Specify"
                        required
                        size="large"
                      />
                    )}
                  />
                  {/* <ErrorMessage
                    show={
                      errors.of_acs_otp_service_other &&
                      methods.formState.touchedFields.of_acs_otp_service_other
                        ? true
                        : false
                    }
                    message={
                      errors.of_acs_otp_service_other?.message ??
                      "Invalid input"
                    }
                  /> */}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default SecureEcommerce;
